import React, { useEffect, useState } from "react";
import { departmentKeyValue1, getActiveItemsByWarehouseid, getWarehouseKeyValueList } from "../../../services";
import { Toaster, toast } from "react-hot-toast";
import ReceiptIcon from "@mui/icons-material/Receipt";
import Select from "react-select";
import AddIcon from "@mui/icons-material/Add";
import { Spinner } from "react-bootstrap";
import Button from "@mui/material/Button";
import { addDepStockClosing } from "../../../services/Inventory/OtherServices";
import { Navigate, useNavigate } from "react-router-dom";

const DepartmentStockClosingNew = () => {
    const [warehouseOptions, setWarehouseOptions] = useState(null);
    const [selectedWarehouse, setSelectedWarehouse] = useState(null);
    const [selectedDepartment,setSelectedDepartment]=useState(null)
    const[selectedDepartmentOptions,setSelectedDepartmentOptions]=useState(null)
    const tempRow = {
        closingStockBoxQuantity: "",
        closingStockOpenQuantity: "",
        currentStockBoxQuantity: 0,
        currentStockOpenQuantity: 0,
        unitName: "",
        packUnitTitle: "",
        itemId: null,
        value: null,
        itemTitle: "",
    };
    const [itemOptions, setItemOptions] = useState(null);
    const [itemOptions2, setItemOptions2] = useState(null);
    const [rows, setRows] = useState([tempRow]);
    const [loading, setLoading] = useState(false);
    const [itemLoading, setItemLoading] = useState(false);
    let navigate = useNavigate();

    useEffect(() => {
        getWarehouseKeyValueList().then((res) => {
            if (res.errorCode === 0) {
                const options = res?.responsePacket.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setWarehouseOptions(options);
                setSelectedWarehouse(options[0]);
            } else {
                toast(res.message);
            }
        });
        
        departmentKeyValue1().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setSelectedDepartmentOptions(options)
                setSelectedDepartment(options[0])
            }
        })
    }, []);

    useEffect(() => {
        if (selectedWarehouse) {
            getWarehouseItems();
        }
    }, [selectedWarehouse]);

    const getWarehouseItems = () => {
        let data = {
            page: 0,
            search: "",
            size: -1,
            uuid: selectedWarehouse.value,
        };
        setItemLoading(true);
        getActiveItemsByWarehouseid(data).then((res) => {
            if (res.errorCode === 0) {
                const options = res?.responsePacket.data?.map((d) => ({
                    itemId: d.itemId,
                    value: d.itemTitle,
                    itemTitle: d.itemTitle,
                    label: d.itemTitle,
                    currentStockBoxQuantity: d.currentStockBoxQuantity,
                    currentStockOpenQuantity: d.currentStockOpenQuantity,
                    closingStockBoxQuantity: "",
                    closingStockOpenQuantity: "",
                    packUnitTitle: d.packUnitTitle,
                    unitName: d.unitName,
                    label: (
                        <div className="selectItemOptions">
                            <div className="font-size-14 font-weight-bold">{d.itemTitle}</div>
                            <div className={`row font-size-13 ${d.currentStockBoxQuantity <= 0 && d.currentStockOpenQuantity <= 0 ? "text-danger" : ""}`}>
                                <div className="col-6">Available Stock:</div>
                                <div className="col-3">
                                    <span>
                                        {d.currentStockBoxQuantity?.toFixed(2)} ({d.packUnitTitle})
                                    </span>
                                </div>
                                <div className="col-3">
                                    <span>
                                        {d.currentStockOpenQuantity?.toFixed(2)} ({d.unitName})
                                    </span>
                                </div>
                            </div>
                            <span className="font-size-13">Rate: {d.sellingPriceValue}</span>
                        </div>
                    ),
                }));
                setItemLoading(false);
                setItemOptions(options);
                setItemOptions2(options);
            } else {
                toast(res.message);
            }
        });
    };

    const handleSelectWarehouse = (e) => {
        setRows([tempRow]);
        setSelectedWarehouse(e);
    };
    const handleSelectDepartement = (e) => {
        setSelectedDepartment(e);
    };

    const handleItem = (e, i) => {
        const obj = [...rows];
        obj[i].itemId = e.itemId;
        obj[i].value = e.value;
        obj[i].itemTitle = e.itemTitle;
        obj[i].label = e.itemTitle;
        obj[i].currentStockBoxQuantity = e.currentStockBoxQuantity;
        obj[i].currentStockOpenQuantity = e.currentStockOpenQuantity;
        obj[i].closingStockBoxQuantity = e.closingStockBoxQuantity;
        obj[i].closingStockOpenQuantity = e.closingStockOpenQuantity;
        obj[i].unitName = e.unitName;
        obj[i].packUnitTitle = e.packUnitTitle;
        setRows(obj);

        var setSend = false;
        var filterOptions = [];
        itemOptions2 &&
            itemOptions2?.map((a) => {
                obj &&
                    obj?.map((b) => {
                        if (a.itemId === b.itemId) {
                            setSend = true;
                        }
                    });
                if (!setSend) {
                    filterOptions.push(a);
                }
                setSend = false;
            });
        setItemOptions(filterOptions);
    };

    const handleAddRow = () => {
        setRows([...rows, tempRow]);
    };

    const handleClear = (id, i) => {
        const obj = rows.slice();
        obj.splice(i, 1);
        setRows(obj);
    };

    const handleBoxQty = (e, i) => {
        const obj = [...rows];
        if (e.target.value === "") {
            obj[i].closingStockBoxQuantity = "";
            setRows(obj);
            return;
        }
        let qt = Number(e.target.value);
        obj[i].closingStockBoxQuantity = qt;
        setRows(obj);
    };

    const handleOpenQty = (e, i) => {
        const obj = [...rows];
        if (e.target.value === "") {
            obj[i].closingStockOpenQuantity = "";
            setRows(obj);
            return;
        }
        let qt = Number(e.target.value);
        obj[i].closingStockOpenQuantity = qt;
        setRows(obj);
    };

    const handleSave = () => {
        if (!selectedWarehouse) {
            toast("Select Warehouse");
            return;
        }
        if (!selectedDepartment) {
            toast("Select Department");
            return;
        }
        setLoading(true);
        let itemBeanList = [];
        rows?.map((item) => {
            if (item.closingStockBoxQuantity !== "" || item.closingStockOpenQuantity !== "") {
                const itemObj = {
                    itemUuId: item?.itemId,
                    openQuantity:item?.closingStockOpenQuantity,
                    boxQuantity: item?.closingStockBoxQuantity
                    // itemId: item.itemId,
                    // itemTitle: item.itemTitle,
                    // currentStockBoxQuantity: item.currentStockBoxQuantity,
                    // currentStockOpenQuantity: item.currentStockOpenQuantity,
                    // closingStockBoxQuantity: item.closingStockBoxQuantity !== "" ? item.closingStockBoxQuantity : 0,
                    // closingStockOpenQuantity: item.closingStockOpenQuantity !== "" ? item.closingStockOpenQuantity : 0,
                };
                itemBeanList.push(itemObj);
            }
        });
        if (itemBeanList?.length === 0) {
            toast("Select item");
            setLoading(false);
            return;
        }
        addDepStockClosing(selectedWarehouse.value,selectedDepartment.value, itemBeanList).then((res) => {
            if (res.errorCode === 0) {
                toast.success(res.message);
                navigate("/departmentstockClosing/list");
                setLoading(false);
                setSelectedWarehouse(warehouseOptions[0]);
                setRows([tempRow]);
            } else {
                toast(res.message);
                return;
            }
        });
    };

    return (
        <>
            <div className="pl-3">
                <h1 className="fill list-header d-flex  align-items-center bg-white p-3 border-bottom">
                    <ReceiptIcon />
                    New Department  Stock Closing
                </h1>

                <br />
                <div className="d-flex">
                <div className="d-flex align-items-center pl-3">
                    <div className="mr-4">Warehouse:</div>
                    <div style={{ minWidth: "200px" }}>
                        <Select value={selectedWarehouse} isDisabled={!warehouseOptions} options={warehouseOptions} onChange={(e) => handleSelectWarehouse(e)} />
                    </div>
                </div>
                <div className="d-flex align-items-center pl-3">
                    <div className="mr-4">Department:</div>
                    <div style={{ minWidth: "200px" }}>
                        <Select value={selectedDepartment} isDisabled={!warehouseOptions} options={selectedDepartmentOptions} onChange={(e) => handleSelectDepartement(e)} />
                    </div>
                </div>

                </div>
                
                <br />
                <table className="customTable">
                    <tbody>
                        <tr>
                            <td></td>
                            <td>Item</td>
                            <td>Current Pack Qty</td>
                            <td>Closing Box Qty</td>
                            <td>Current Loose Qty</td>
                            <td>Closing Loose Qty</td>
                        </tr>
                        {rows &&
                            rows?.map((data, i) => {
                                return (
                                    <tr key={i}>
                                        <td>
                                            <div className={itemLoading ? "spinner-loader" : ""}></div>
                                        </td>
                                        <td className="selectMenuItemList" style={{ width: "300px" }}>
                                            <Select isDisabled={!selectedWarehouse || itemLoading} options={itemOptions} value={data} onChange={(e) => handleItem(e, i)} />
                                        </td>
                                        <td>
                                            <span>{data.currentStockBoxQuantity + " " + data.packUnitTitle}</span>
                                        </td>
                                        <td>
                                            <input disabled={!selectedWarehouse || itemLoading} autoComplete="off" min={0} type="number" value={data.closingStockBoxQuantity} onChange={(e) => handleBoxQty(e, i)} />
                                        </td>
                                        <td>
                                            <span>{data.currentStockOpenQuantity + " " + data.unitName}</span>
                                        </td>
                                        <td>
                                            <input disabled={!selectedWarehouse || itemLoading} autoComplete="off" min={0} type="number" value={data.closingStockOpenQuantity} onChange={(e) => handleOpenQty(e, i)} />
                                        </td>
                                        <td style={{ cursor: "pointer" }} onClick={() => handleClear(data.itemId, i)}>
                                            {rows.length > 1 && <i className="fa fa-times"></i>}
                                        </td>
                                    </tr>
                                );
                            })}
                    </tbody>
                </table>

                {selectedWarehouse && (
                    <>
                        <div>
                            <button id="ember1426" className="btn btn-default addbtn mt-3" onClick={handleAddRow}>
                                <AddIcon style={{ color: "blue" }} /> New Row
                            </button>
                        </div>
                        <br />
                        <div>
                            {loading ? (
                                <Button variant="contained">
                                    <Spinner />
                                </Button>
                            ) : (
                                <Button variant="contained" onClick={handleSave}>
                                    Save
                                </Button>
                            )}
                        </div>
                    </>
                )}
            </div>
            <Toaster />
        </>
    );
};

export default DepartmentStockClosingNew;
